// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SchematisationUserSuppliedMeta
 */
export interface SchematisationUserSuppliedMeta {
  /**
   *
   */
  id?: number | null;
  /**
   *
   */
  revisionId?: number | null;
}

/**
 * Check if a given object implements the SchematisationUserSuppliedMeta interface.
 */
export function instanceOfSchematisationUserSuppliedMeta(
  value: object
): value is SchematisationUserSuppliedMeta {
  return true;
}

export function SchematisationUserSuppliedMetaFromJSON(json: any): SchematisationUserSuppliedMeta {
  return SchematisationUserSuppliedMetaFromJSONTyped(json, false);
}

export function SchematisationUserSuppliedMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SchematisationUserSuppliedMeta {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] === undefined ? undefined : json["id"] === null ? null : json["id"],
    revisionId:
      json["revision_id"] === undefined
        ? undefined
        : json["revision_id"] === null
        ? null
        : json["revision_id"],
  };
}

export function SchematisationUserSuppliedMetaToJSON(json: any): SchematisationUserSuppliedMeta {
  return SchematisationUserSuppliedMetaToJSONTyped(json, false);
}

export function SchematisationUserSuppliedMetaToJSONTyped(
  value?: SchematisationUserSuppliedMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    revision_id: value["revisionId"],
  };
}
